import {ReactElement} from "react";
import Schedule from "../pages/db/modules/Schedule";
import ProjectMng from "../pages/db/modules/ProjectMng";
import ActivityLog from "../pages/db/modules/ActivityLog";
import ActivityFeed from "../pages/db/modules/ActivityFeed";
import IssueMng from "../pages/db/modules/IssueMng";
import NoticeNews from "../pages/db/modules/NoticeNews";
import EnergySplyStatus from "../pages/db/modules/EnergySplyStatus";
import EnergyConsumStatus from "../pages/db/modules/EnergyConsumStatus";
import DbUserRealTimePowerGen from "../pages/db/client/DbUserRealTimePowerGen";
import DbUserDayPowerGen from "../pages/db/client/DbUserDayPowerGen";
import LoadUsage from "../pages/db/modules/LoadUsage";
import ElecUsageFee from "../pages/db/modules/ElecUsageFee";
import EssLiveStatus from "../pages/db/modules/EssLiveStatus";
import FlexResource from "../pages/db/modules/FlexResource";
import ReAchievementRate from "../pages/db/modules/ReAchievementRate";
import ReGoalPfrc from "../pages/db/modules/ReGoalPfrc";
import ImplementResult from "../pages/db/modules/ImplementResult";
import FuflMeansRt from "../pages/db/modules/FuflMeansRt";
import MonthlySmcnCert from "../pages/db/modules/MonthlySmcnCert";
import DbRlibr from "../pages/db/modules/DbRlibr";
import GhgsEmissQnt from "../pages/db/modules/GhgsEmissQnt";
import RdcGoal from "../pages/db/modules/RdcGoal";
import GhgsEmissQntTrend from "../pages/db/modules/GhgsEmissQntTrend";
import FacilityGhgsEmissQnt from "../pages/db/modules/FacilityGhgsEmissQnt";
import MonthlyImplementResult from "../pages/db/modules/MonthlyImplementResult";
import BizPlndStatus from "../pages/db/modules/BizPlndStatus";
import TrdPrcnd from "../pages/db/modules/TrdPrcnd";
import CntrMng from "../pages/db/modules/CntrMng";
import PchsDesc from "../pages/db/modules/PchsDesc";
import SaleDesc from "../pages/db/modules/SaleDesc";
import RecPrcInfo from "../pages/db/modules/RecPrcInfo";
import EmcrdPrcInfo from "../pages/db/modules/EmcrdPrcInfo";
import {DbUserConfigModel} from "../model/db/dbUserConfigModel";
import EquipmentStatus from "../pages/db/modules/ EquipmentStatus";

export class DashboardUtils {
  public static getDashboardModuleByName(
    name: string,
    isConfigMode: boolean = false,
    dashboardConfig?: DbUserConfigModel
  ): ReactElement {
    switch (name) {
      case 'Schedule':
        return <Schedule isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ProjectMng':
        return <ProjectMng isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ActivityLog':
        return <ActivityLog isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ActivityFeed':
        return <ActivityFeed isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'IssueMng':
        return <IssueMng isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'NoticeNews':
        return <NoticeNews isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'EnergySplyStatus':
        return <EnergySplyStatus isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'EnergyConsumStatus':
        return <EnergyConsumStatus isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'DbUserRealTimePowerGen':
        return <DbUserRealTimePowerGen isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'DbUserDayPowerGen':
        return <DbUserDayPowerGen isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'LoadUsage':
        return <LoadUsage isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ElecUsageFee':
        return <ElecUsageFee isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'EssLiveStatus':
        return <EssLiveStatus isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'FlexResource':
        return <FlexResource isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ReAchievementRate':
        return <ReAchievementRate isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ReGoalPfrc':
        return <ReGoalPfrc isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'ImplementResult':
        return <ImplementResult isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'FuflMeansRt':
        return <FuflMeansRt isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'MonthlySmcnCert':
        return <MonthlySmcnCert isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'DbRlibr':
        return <DbRlibr isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'GhgsEmissQnt':
        return <GhgsEmissQnt isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'RdcGoal':
        return <RdcGoal isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'GhgsEmissQntTrend':
        return <GhgsEmissQntTrend isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'FacilityGhgsEmissQnt':
        return <FacilityGhgsEmissQnt isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'MonthlyImplementResult':
        return <MonthlyImplementResult isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'BizPlndStatus':
        return <BizPlndStatus isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'TrdPrcnd':
        return <TrdPrcnd isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'CntrMng':
        return <CntrMng isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'PchsDesc':
        return <PchsDesc isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'SaleDesc':
        return <SaleDesc isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'RecPrcInfo':
        return <RecPrcInfo isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'EmcrdPrcInfo':
        return <EmcrdPrcInfo isConfigMode={isConfigMode} dashboardConfig={dashboardConfig} />;
      case 'EquipmentStatus' :
        return <EquipmentStatus isConfigMode={isConfigMode} dashboardConfig={dashboardConfig}/>;
      default:
        return <></>;
    }
  }
}